import { Dictionary } from "flow/api/types";
import environment from "flow/configuration/environment";

const loadedUrls: Dictionary<boolean> = {};

function load(url: string, cacheBuster?: string) {
    if (loadedUrls[url] !== undefined) {
        return;
    }

    loadedUrls[url] = true;

    const link = document.createElement("link");
    link.rel = "stylesheet";

    if (url.indexOf("#print") >= 0) {
        url = url.replace("#print", "");
        link.media = "print";
    } else if (url.indexOf("#screen") >= 0) {
        url = url.replace("#screen", "");
        link.media = "screen";
    }

    if (!cacheBuster) {
        cacheBuster = environment.get(environment.keys.version);
    }

    const args = "bust=" + cacheBuster;
    const busterQuery = (url.indexOf("?") === -1 ? "?" : "&") + args;

    link.href = url + busterQuery;
    document.getElementsByTagName("head")[0].appendChild(link);
}

function loadBatch(urls: string[], cacheBuster?: string) {
    if (urls && urls.length > 0) {
        urls.forEach(url => {
            load(url, cacheBuster);
        });
    }
}

export default {
    load: load,
    loadBatch: loadBatch
};
